import { ILgpHeroSticky, LgpHeroSticky } from "@sky-it-livedata/livedata-sports-design-system";
import { useEffect } from "react";
import { graphql } from "cdk/graphql";

import transformQuery from "./transformers/query-transformer";
import transformSubscription from "./transformers/subscription-transformer";
import { LgpHeroStickyQuery, LgpHeroStickySubscription } from "./types";
import { log } from "../../utils/log";
import { useSubscription } from "../../hooks/useSubscription";
import { WidgetContext } from "../../types/WidgetContext";
import { lgpHeaderModalContentData, handleZindexes, restoreZindexes, lockPageScroll, unlockPageScroll } from "../../utils/modals";
import { analyticsTrack } from "../../utils/analytics";
import { LGP_HERO_STICKY_MODAL_CLOSE_EVENT, LGP_HERO_STICKY_MODAL_OPEN_EVENT } from "@sky-it-livedata/livedata-sports-design-system";

export const setCustomAttributes = ({variables}: WidgetContext<LgpHeroStickyQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

const subscriptionDocument = graphql('subscription UpdateLgpHeroStickyWidget($gpId: ID!, $seasonAndCompId: ID!) {\n  onUpdateLgpHeroStickyBySeasonAndCompIdAndGpId(\n    gpId: $gpId\n    seasonAndCompId: $seasonAndCompId\n  ) {\n    gpId\n    seasonAndCompId\n    session {\n      label\n      name\n      status\n    }\n    info {\n      customGpName\n      endDate\n      flagImgUrl\n      startDate\n    }\n  }\n}');

export function getServerProps({
  props,
}: WidgetContext<LgpHeroStickyQuery>): ILgpHeroSticky {
  return transformQuery(props);
}

const LgpHeroStickyWidget = ({props,
  variables,
  ...rest
}: WidgetContext<ILgpHeroSticky>) => {
  log({ props, variables, ...rest });

  const updatedProps = useSubscription<
    ILgpHeroSticky,
    LgpHeroStickySubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: false,
  }) as ILgpHeroSticky;

    useEffect(() => {
      if (updatedProps.sessionStatus !== "Playing") {
        return;
      }

      const onLgpHeroModalOpen = () => {
        lockPageScroll();
        analyticsTrack('modal_open', 'modal_name', 'lgp_hero_modal' );
        handleZindexes();
      };
  
      const onLgpHeroModalClose = () => {
        analyticsTrack('modal_close', 'modal_name', 'lgp_hero_modal' );
        unlockPageScroll();
        restoreZindexes();
      };
  
      window.addEventListener(LGP_HERO_STICKY_MODAL_OPEN_EVENT, onLgpHeroModalOpen);
      window.addEventListener(LGP_HERO_STICKY_MODAL_CLOSE_EVENT, onLgpHeroModalClose);
      return () => {
        window.removeEventListener(LGP_HERO_STICKY_MODAL_OPEN_EVENT, onLgpHeroModalOpen);
        window.removeEventListener(LGP_HERO_STICKY_MODAL_CLOSE_EVENT, onLgpHeroModalClose);
      };
    }, [updatedProps.sessionStatus]);

  return ( <LgpHeroSticky {...updatedProps} modalContentData={lgpHeaderModalContentData} /> );
}

export default LgpHeroStickyWidget;